export default function PromotedSearchResults({searchTerm, searchResults, total = null, limit}) {
  return (
    <>
      {
        searchResults.length > 0 && searchResults.slice(0, limit).map((result, index) =>
          <article className={"search-result--promoted promoted-search"}>
            <div className={"promoted-search__meta metalabels"}>
              <span className="promoted-search__label metalabel">
                Uitgelicht
              </span>
            </div>
            <h3 className={"promoted-search__title"}>
              <a href={result.url}>
                {result.title}
              </a>
            </h3>
            <svg className="icon icon-mm-link-arrow">
              <use xlinkHref="#icon-mm-link-arrow"></use>
            </svg>
          </article>
        )
      }
    </>
  );
}
